import { useResource } from '@landsbankinn/l16n';
import React from 'react';
import type { SmartBookingCustomerInput } from '../../../../../../__generated__/globalTypes';
import { useAppointmentContext } from '../../../../book-appointment/BookAppointment';
import { InputContainer } from '../../../../book-appointment/shared/InputContainer';
import { EmailInput } from '../EmailInput';
import { KennitalaInput } from '../KennitalaInput';
import { NameInput } from '../NameInput';
import { PhoneInput } from '../PhoneInput';
import res from './PersonInfo.res';

interface IProps {
  setKennitalaNotFound: React.Dispatch<React.SetStateAction<boolean>>;
  kennitalaNotFound: boolean;
}

export function PersonInfo({
  setKennitalaNotFound,
  kennitalaNotFound,
}: IProps) {
  const { r } = useResource();

  const { state, dispatch } = useAppointmentContext();
  const { customerInfo } = state;

  const setCustomerInfo = (customerInfo: SmartBookingCustomerInput) => {
    dispatch?.({ type: 'setCustomerInfo', customerInfo });
  };

  return (
    <>
      <InputContainer>
        <NameInput
          placeholder={r(res.name)}
          value={customerInfo?.name as any}
          onChange={(name) => setCustomerInfo({ ...customerInfo, name } as any)}
        />
        <KennitalaInput
          placeholder={r(res.kennitala)}
          value={customerInfo?.kennitala as any}
          kennitalaNotFound={kennitalaNotFound}
          onChange={(kennitala) => {
            if (kennitalaNotFound) {
              setKennitalaNotFound(false);
            }
            setCustomerInfo({ ...customerInfo, kennitala } as any);
          }}
        />
        <EmailInput
          placeholder={r(res.email)}
          value={customerInfo?.email as any}
          onChange={(email) =>
            setCustomerInfo({ ...customerInfo, email } as any)
          }
        />
        <PhoneInput
          placeholder={r(res.phonenumer)}
          value={customerInfo?.phone as any}
          onChange={(phone) =>
            setCustomerInfo({ ...customerInfo, phone } as any)
          }
        />
      </InputContainer>
    </>
  );
}
